module.exports = __webpack_public_path__ + "static/media/background-remover.823a595b.png";